module.exports = __webpack_public_path__ + "img/cardio10.6d638e9c.jpg";